<template>
    <form :class="[$style['mds-form'], layoutSizeClass]" :data-mds-version="version">
        <slot></slot>
    </form>
</template>

<script>
    // Import component's API
    import MdsFormProps from './form_props.js';

    export default {
        name: 'MdsForm',
        props: MdsFormProps,
        computed: {
            layoutSizeClass() {
                return this.$style[`mds-form--${this.size}-layout`];
            },
        },
    };
</script>

<style lang="scss" module>
    @import './form.scss';
</style>
